import { useEffect, useState } from 'react'

import { getBackendProductIntent } from 'api/application'
import { OctaneLogger } from 'integrations/datadog/OctaneLogger'

export interface ProductIntent {
    tradeIn: boolean
    accessories: boolean
    insurance: boolean
    warranty: boolean
    trailer: boolean
}

interface BackendProductIntentData {
    lead_uuid?: string
    backend_product_intent?: {
        trade_in_intent: boolean
        accessories_intent: boolean
        warranty_intent: boolean
        insurance_intent: boolean
        trailer_intent: boolean
    }
    status?: string
}

export interface UseBackendProductIntentProps {
    productIntent: ProductIntent | undefined
    loading: boolean
    error?: ErrorInterface | null
    notLead?: boolean
}

export interface ErrorInterface {
    notLead?: boolean
    server?: boolean
}

const useBackendProductIntent = (
    applicationUuid: string,
): UseBackendProductIntentProps => {
    const [productIntent, setProductIntent] = useState<ProductIntent>()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<ErrorInterface | null>(null)

    useEffect(() => {
        const abortController = new AbortController()

        const loadProductIntents = async () => {
            return getBackendProductIntent(applicationUuid, abortController)
        }

        if (!applicationUuid) {
            return
        }

        loadProductIntents()
            .then((data: BackendProductIntentData) => {
                // setError(false)

                if (data.status === 'not_lead_connected')
                    setError({ notLead: true })

                if (data.backend_product_intent)
                    setProductIntent({
                        tradeIn: data.backend_product_intent.trade_in_intent,
                        accessories:
                            data.backend_product_intent.accessories_intent,
                        warranty: data.backend_product_intent.warranty_intent,
                        insurance: data.backend_product_intent.insurance_intent,
                        trailer: data.backend_product_intent.trailer_intent,
                    })
            })
            .catch((bpiError) => {
                OctaneLogger.error(
                    'Error when getting backend product intents.',
                    { applicationUuid },
                    bpiError as Error,
                )

                setError({ server: true })
            })
            .finally(() => {
                setLoading(false)
            })

        return () => abortController.abort()
    }, [applicationUuid])

    return {
        productIntent,
        loading,
        error,
    }
}

export default useBackendProductIntent
